import { useToast } from "@chakra-ui/react";

export const useCustomToast = () => {
  const toast = useToast();

  const showToast = ({ description, status, duration, position }) => {
    toast({
      description: description || "Action performed successfully.",
      status: status || "info",
      duration: duration || 2000,
      isClosable: true,
      position: position || "bottom",
      containerStyle: {
        color: "#fff",
      },
    });
  };

  return showToast;
};
